import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Row, Col, Hidden } from "react-grid-system";
import { Property, zindex, color } from "./style/Variables.js";
import { Logo } from "./Blocks.js";

export const navHeight = new Property(6, "em");

const NavContainer = styled.nav`
  @media (max-width: 899px) {
    height: 4em;
  }
  @media (min-width: 900px) {
    top: 2.5rem;
    left: 0;
  }

  position: absolute;
  left: 0;
  right: 0;
  top: 80px;
  width: 100%;
  & > div {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  height: ${navHeight.css};

  z-index: ${zindex.navigation};

  .menu-item:not(:last-child) {
    margin-right: 44px;
  }

  &.transparent {
    background: transparent;
    color: ${color.white};
    a {
      color: ${color.white};
      &:hover {
        color: ${color.light_turquoise};
      }
    }
  }
  &.normal {
    background: ${color.white};
    color: ${color.turquoise};
    a {
      color: ${color.turquoise};
    }
  }
  transition: background-color 0.4s ease, color 0.4s ease;

  .logo {
    @media (max-width: 768px) {
      width: 250px;
      height: auto;
    }
    @media (max-width: 767px) {
      width: 180px;
    }
  }
`;

class Navigation extends React.Component {
  static contextTypes = {
    copy: PropTypes.object,
  };
  render() {
    const copy = this.context.copy.get("Navigation");

    return (
      <React.Fragment>
        <NavContainer className="transparent font-regular">
          <Row>
            <Col
              sm={12}
              md={11}
              lg={9.6}
              offset={{ sm: 0, md: 0, lg: 1.2 }}
              className="h-100 px4"
            >
              <Row
                className="h-100 line-height-3"
                style={{ alignItems: "center" }}
              >
                <Col
                  className="flex items-center"
                  style={
                    window.innerWidth < 900
                      ? {
                          justifyContent: "center",
                        }
                      : { padding: 0 }
                  }
                  md={2.4}
                >
                  <Logo />
                </Col>
                <Hidden xs sm>
                  <div className="right-align block w-80">
                    <div className="inline-block">
                      {copy &&
                        copy.menuItems.map((item, index) => (
                          <span
                            key={index}
                            className={`menu-item ${
                              item.icon ? item.icon : ""
                            }`}
                          >
                            <a href={item.url} className="py2">
                              {item.title}
                            </a>
                          </span>
                        ))}
                    </div>
                  </div>
                </Hidden>
              </Row>
            </Col>
          </Row>
        </NavContainer>
      </React.Fragment>
    );
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/Navigation.js